import { render, staticRenderFns } from "./ArrendamientoGeneral.vue?vue&type=template&id=ede7ca7c&"
import script from "./ArrendamientoGeneral.vue?vue&type=script&lang=js&"
export * from "./ArrendamientoGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports